export const state_training_children = [
  { id: 1, name: "Был" },
  { id: 2, name: "Не был" },
  { id: 3, name: "Отменена" },
];
